import React, { PureComponent } from 'react'
import get from 'lodash/get'
import map from 'lodash/map'
import { withTranslation } from 'react-i18next'

import ErrorLabel from 'app/components/ErrorLabel'
import DayButton from './DayButton'

import './styles.scss'
const bc = 'work-week-field'

export class WorkWeekFieldArray extends PureComponent {
  state = {
    workWeek: {
      Sun: false,
      Mon: true,
      Tue: true,
      Wed: true,
      Thu: true,
      Fri: true,
      Sat: false,
    },
  }

  componentDidMount() {
    this.setWorkWeek(this.props)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fields !== this.props.fields) {
      this.setWorkWeek(this.props)
    }
  }

  setWorkWeek = props => {
    const fields = props.fields.getAll()
    if (fields) {
      this.setState({
        workWeek: {
          Sun: fields.includes('Sun'),
          Mon: fields.includes('Mon'),
          Tue: fields.includes('Tue'),
          Wed: fields.includes('Wed'),
          Thu: fields.includes('Thu'),
          Fri: fields.includes('Fri'),
          Sat: fields.includes('Sat'),
        },
      })
    } else {
      this.setState({
        workWeek: {
          Sun: false,
          Mon: false,
          Tue: false,
          Wed: false,
          Thu: false,
          Fri: false,
          Sat: false,
        },
      })
    }
  }

  toggleWorkDay = e => {
    const day = get(e, ['target', 'dataset', 'day'])
    if (!day) {
      throw new Error('Unknown attributes target.dataset.day required for WorkWeekFieldArray')
    }
    const { fields } = this.props
    const all = fields.getAll()
    const existingDayIndex = all ? all.findIndex(el => el === day) : -1
    if (~existingDayIndex) {
      fields.remove(existingDayIndex)
    } else {
      fields.push(day)
    }
  }

  render() {
    const { t, fields, meta: { error } } = this.props
    const { workWeek } = this.state
    return (
      <div className={`${bc}__wrapper`}>
        <h4 className={`${bc}__subtitle`}>{t('What days do you work?')}</h4>
        <div>
          {map(workWeek, (checked, day) => (
            <DayButton key={day} onClick={this.toggleWorkDay} data-day={day} checked={checked}>
              {t(day)}
            </DayButton>
          ))}
        </div>
        {error && <ErrorLabel error={error} htmlFor={fields.name} />}
      </div>
    )
  }
}

export default withTranslation('user')(WorkWeekFieldArray)
